import React from "react";

const Group = ({ children }) => <div>{children}</div>;

export default Group;
